module.exports = __webpack_public_path__ + "media/olimar.46afc192.wav";